import { isDefined as s } from "@scalar/helpers/array/is-defined";
import { getResolvedRef as t } from "@scalar/workspace-store/helpers/get-resolved-ref";
const c = (o = [], a = []) => {
  const m = [...o, ...a].map((e) => t(e)).filter(s), r = /* @__PURE__ */ new Map();
  for (const e of m) {
    const n = `${e.in}:${e.name}`;
    r.set(n, e);
  }
  return Array.from(r.values());
};
export {
  c as combineParams
};
